import { rupiah, monthLabel, dateLabel, PAYMENT_STATUS } from "@/lib/format";
import { Sheet, Header, Footer, Title, Signatures, signer } from "@/components/PrintDocs";

const Summary = ({ items }) => (
  <div className="grid grid-cols-4 gap-3 mb-4">
    {items.map(([k, v]) => (
      <div key={k} className="rounded-xl bg-amber-50 border border-amber-100 p-3 text-center">
        <div className="font-display text-lg font-bold text-slate-900">{v}</div>
        <div className="text-[10px] text-slate-500">{k}</div>
      </div>
    ))}
  </div>
);

const th = "py-2 px-2 text-left font-semibold text-[11px]";
const td = "py-1.5 px-2 border-b border-slate-100 text-[11px] whitespace-nowrap";

export function RekapKehadiran({ settings, report }) {
  const { rows = [], summary = {}, month } = report || {};
  const pct = summary.total_sesi ? Math.round((summary.hadir / summary.total_sesi) * 100) : 0;
  return (
    <Sheet size="rekap-kehadiran" testId="rekap-kehadiran-doc">
      <Header settings={settings} />
      <Title color="bg-sky-100 text-sky-600" sub={`Periode: ${monthLabel(month)}`}>REKAP KEHADIRAN BULANAN</Title>
      <Summary items={[["Siswa Aktif", summary.students], ["Total Sesi", summary.total_sesi], ["Hadir", summary.hadir], ["% Kehadiran", `${pct}%`]]} />
      <table className="w-full">
        <thead><tr className="bg-sky-50 text-sky-700">
          <th className={th}>No</th><th className={th}>Nama Siswa</th><th className={th}>Jenjang</th>
          <th className={`${th} text-center`}>Hadir</th><th className={`${th} text-center`}>Izin</th><th className={`${th} text-center`}>Sakit</th><th className={`${th} text-center`}>Alpa</th><th className={`${th} text-center`}>%</th>
        </tr></thead>
        <tbody>
          {rows.map((r, i) => (
            <tr key={r.id}>
              <td className={td}>{i + 1}</td><td className={`${td} font-medium`}>{r.name}</td><td className={td}>{r.class_label || r.level}</td>
              <td className={`${td} text-center text-emerald-600 font-semibold`}>{r.hadir}</td><td className={`${td} text-center`}>{r.izin}</td>
              <td className={`${td} text-center`}>{r.sakit}</td><td className={`${td} text-center text-rose-600`}>{r.alpa}</td>
              <td className={`${td} text-center font-bold`}>{r.total_sesi ? `${r.attendance_pct}%` : "-"}</td>
            </tr>
          ))}
          {rows.length === 0 && <tr><td colSpan={8} className="py-6 text-center text-slate-400">Tidak ada data.</td></tr>}
        </tbody>
      </table>
      <Signatures right={{ role: "Admin", name: signer(settings) }} />
      <Footer settings={settings} />
    </Sheet>
  );
}

export function RekapPembayaran({ settings, report }) {
  const { rows = [], summary = {}, month } = report || {};
  return (
    <Sheet size="rekap-pembayaran" testId="rekap-pembayaran-doc">
      <Header settings={settings} />
      <Title color="bg-emerald-100 text-emerald-600" sub={`Periode: ${monthLabel(month)}`}>REKAP PEMBAYARAN BULANAN</Title>
      <Summary items={[["Siswa Aktif", summary.students], ["Lunas", summary.lunas], ["Terkumpul", rupiah(summary.collected)], ["Target", rupiah(summary.target)]]} />
      <table className="w-full">
        <thead><tr className="bg-emerald-50 text-emerald-700">
          <th className={th}>No</th><th className={th}>Nama Siswa</th><th className={th}>Jenjang</th>
          <th className={`${th} text-right`}>Tagihan</th><th className={`${th} text-right`}>Dibayar</th><th className={th}>Tgl Bayar</th><th className={`${th} text-center`}>Status</th>
        </tr></thead>
        <tbody>
          {rows.map((r, i) => {
            const p = r.payment; const st = p ? PAYMENT_STATUS[p.status] : null;
            return (
              <tr key={r.id}>
                <td className={td}>{i + 1}</td><td className={`${td} font-medium`}>{r.name}</td><td className={td}>{r.class_label || r.level}</td>
                <td className={`${td} text-right`}>{p ? rupiah(p.amount_due) : "-"}</td><td className={`${td} text-right font-semibold`}>{p ? rupiah(p.amount_paid) : "-"}</td>
                <td className={td}>{p?.paid_date ? dateLabel(p.paid_date) : "-"}</td>
                <td className={`${td} text-center`}>{st ? <span className={`px-2 py-0.5 rounded-full border text-[10px] font-semibold ${st.cls}`}>{st.label}</span> : <span className="text-slate-300 text-[10px]">belum ada tagihan</span>}</td>
              </tr>
            );
          })}
          {rows.length === 0 && <tr><td colSpan={7} className="py-6 text-center text-slate-400">Tidak ada data.</td></tr>}
        </tbody>
      </table>
      <Signatures right={{ role: "Admin", name: signer(settings) }} />
      <Footer settings={settings} />
    </Sheet>
  );
}
